module.exports = __webpack_public_path__ + "img/HS-8.fa0dae28.jpg";